module.exports = __webpack_public_path__ + "static/media/stable.eb8e9eb1.svg";